/** Màu thanh theo loại chứng từ; mã lạ dùng `MAU_KHAC`. Bảng tông nằm ở module, không ở `src/mock/`. */
export const MAU_LOAI_CHUNG_TU: Record<string, string> = {
  INVOICE: 'bg-teal-500',
  RECEIPT: 'bg-sky-500',
  CONTRACT: 'bg-primary-500',
  STATEMENT: 'bg-sky-500',
  MINUTES: 'bg-warning-500',
  WAREHOUSE_RECEIPT: 'bg-violet-500',
  OTHERS: 'bg-neutral-400',
};
export const MAU_KHAC = 'bg-neutral-400';

export const MAU_KHO = 'bg-violet-500';

export const PHAM_VI_BOT: Record<string, { khoa: string; mau: string }> = {
  knowledge_only: { khoa: 'baoCao.pv.knowledge_only', mau: 'bg-teal-500' },
  open: { khoa: 'baoCao.pv.open', mau: 'bg-primary-500' },
};

/** Màu xoay vòng cho biểu đồ người dùng theo phòng ban. */
export const MAU_PHONG_BAN = [
  'bg-orange-500',
  'bg-danger-500',
  'bg-teal-500',
  'bg-violet-500',
  'bg-success-500',
  'bg-warning-500',
  'bg-sky-500',
  'bg-primary-500',
  'bg-orange-500',
] as const;

/** Chỉ lấy ngần ấy bộ tri thức đầu cho biểu đồ. */
export const SO_BO_TOI_DA = 6;
